import React, { FC, useCallback, useMemo, useState, useEffect } from 'react';
import {
  Image,
  View,
  ActivityIndicator,
  ViewStyle,
  TouchableOpacity,
  TouchableWithoutFeedback,
  useWindowDimensions,
  Dimensions,
  ScrollView,
} from 'react-native';
import { IS_WEB, MAX_WIDTH } from '../../constants/platform';
import { STYLE_VARS } from '../../constants/style-vars';
import { IHomeState } from './types';
import { Notices } from './components/Notices';

import { Text } from '../../components/Text';
import { User } from './components/User';
import { Promotions } from './components/Promotions';
import { Events } from './components/Events';
import { useNavigation } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../services/redux/store';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { StyleSheet } from 'react-native';
import {
  fetchEvents,
  fetchPromotions,
} from '../../services/redux/reducers/ActionCreators';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import Swiper from 'react-native-web-swiper';
import { Button } from '../../components/Button';
import PagePath from '../../components/PagePath';
import { NavigationService } from '../../services/navigation';
import {
  setEvents,
  setLoadingEvent,
} from '../../services/redux/reducers/EventSlice';
import { EventsApi, PromotionsApi } from '../../services/api';
import DashboardApi from '../../services/api/dashboard.api';
import {
  setDashboard,
  setLoadingDashboard,
} from '../../services/redux/reducers/DashboardSlice';
import {
  setLoadingPromotion,
  setPromotions,
} from '../../services/redux/reducers/PromotionSlice';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import {
  book_sports_facility,
  events,
  events_white,
  e_shop,
  private_function,
  restaurant_reservation,
} from '../../assets/base64';
import ECardMember from '../../components/ECardMember/ECardMember';

interface EventsAndPromotions {
  id: number;
  title: string;
  content: string;
  created_at: Date;
}

const initialHomeState: IHomeState = {
  newsType: 'correspondent',
  loaded: true,
  eventsHeight: 0,
  noticesHeight: 0,
  newsHeight: 0,
  promotionsHeight: 0,
  notices: [],
  events: [],
  promotions: [],
  news: [],
  correspondent: [],
  press_freedom: [],
};

const Home: FC = () => {
  const [state] = useState(initialHomeState);
  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));
  const auth = useSelector((redux: RootState) => redux.authReducer);
  const { width: screenWidth } = useWindowDimensions();
  const { navigate } = useNavigation();
  const isDesktop = useIsDesktop();
  const [openECard, setOpenECard] = useState<boolean>(false);
  const DASHBOARD_MENU = useMemo(() => {
    return [
      {
        title: 'BOOK SPORTS \n& RECREATION',
        icon: IS_WEB
          ? addBase64Prefix(book_sports_facility)
          : require('../../assets/book-sports-facility.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'Sports',
              params: {
                screen: 'Facility',
              },
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'BOOK EVENTS\n',
        icon: IS_WEB
          ? addBase64Prefix(events_white)
          : require('../../assets/events.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'EventList',
              params: {
                screen: 'Grid',
              },
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'RESTAURANT RESERVATION',
        icon: IS_WEB
          ? addBase64Prefix(restaurant_reservation)
          : require('../../assets/restaurant-reservation.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'GrillRoom',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'ECARD \nMEMBER',
        icon: IS_WEB
          ? addBase64Prefix(e_shop)
          : require('../../assets/ecard.png'),
        onPress: () => {
          setOpenECard(true);
        },
        requiredLogin: true,
      },
      {
        title: 'ORDER FROM \nKCC E-SHOP',
        icon: IS_WEB
          ? addBase64Prefix(e_shop)
          : require('../../assets/e-shop.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'EShopHomePage',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'DINING MENUS\n',
        icon: require('../../assets/dining-menus.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'DinningMenu',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'BOOK A PRIVATE FUNCTION',
        icon: IS_WEB
          ? addBase64Prefix(private_function)
          : require('../../assets/private-function.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'PrivateFunction',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'DINING \nPROMOTIONS',
        icon: require('../../assets/dining-promotions.png'),
        onPress: () => {
          if (auth.loggedin === true) {
            NavigationService.push<'Root'>('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'DinningPromotion',
              },
            });
          } else {
            NavigationService.push('DinningPromotion');
          }
        },
        requiredLogin: false,
      },
      {
        title: 'BOOK SPORTS \nCOACHING',
        icon: require('../../assets/book-sports-coaching.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'Sports',
              params: {
                screen: 'Coaching',
              },
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'NEWS \n',
        icon: require('../../assets/news.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'ClubNews',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'NOTICES \n',
        icon: require('../../assets/notices.png'),
        onPress: () => {
          if (auth.loggedin === true) {
            NavigationService.push<'Root'>('Root', {
              screen: 'MenuTab',
              params: {
                screen: 'Notices',
                params: {
                  screen: 'new',
                },
              },
            });
          } else {
            NavigationService.push<'Notices'>('Notices', {
              screen: 'new',
            });
          }
        },
        requiredLogin: false,
      },
      {
        title: 'MY ACCOUNT\n',
        icon: require('../../assets/my-account.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MyAccountTab',
          });
        },
        requiredLogin: true,
      },
      {
        title: 'MY BOOKINGS\n',
        icon: require('../../assets/my-bookings.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MyBookingsTab',
          });
        },
        requiredLogin: true,
      },
      {
        title: 'SERVICES & FORMS\n',
        icon: require('../../assets/services-forms.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'ServiceForm',
            },
          });
        },
        requiredLogin: true,
      },
      {
        title: 'FEEDBACK\n',
        icon: require('../../assets/feedback-icon.png'),
        onPress: () => {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'Feedback',
            },
          });
        },
        requiredLogin: true,
      },
    ];
  }, [auth.loggedin, setOpenECard]);

  const navigateToLogin = useCallback(() => {
    if (user.loggedin) {
      return;
    }
    NavigationService.push('Login');
  }, [user.loggedin]);

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      height: '100%',
      width: '76%',
      resizeMode: 'cover',
      justifyContent: 'flex-start',
    },
    backgroundImage: {
      width: isDesktop() ? undefined : screenWidth,
      height: (isDesktop() ? 550 : screenWidth) * (1346 / 1796),
    },
  });

  const dispatch: ThunkDispatch<RootState, void, AnyAction> = useDispatch();

  const event = useSelector((state: RootState) => state?.eventReducer);
  // const promotion = useSelector((state: RootState) => state?.promotionReducer);
  const dashboard = useSelector((state: RootState) => state?.dashboardReducer);

  const getEvents = useCallback(async () => {
    try {
      const res = await EventsApi.getEvents({ view: 'upcoming' });
      dispatch(setEvents(res.data.events));
    } catch (error: any) {
      console.log(error);
    } finally {
    }
  }, [dispatch]);

  const getDashboard = useCallback(async () => {
    try {
      dispatch(setLoadingDashboard(true));
      const res = await DashboardApi.getDashboard();
      dispatch(setDashboard(res.data));
    } catch (error: any) {
      console.log(error);
    } finally {
      dispatch(setLoadingDashboard(false));
    }
  }, [dispatch]);

  const handleRedirectBanner = useCallback(
    (item: { id: number; type: string; img: string }) => {
      if (item.type === 'event') {
        if (auth.loggedin === false) {
          navigateToLogin();
        } else {
          NavigationService.push<'Root'>('Root', {
            screen: 'MenuTab',
            params: {
              screen: 'EventDetail',
              params: {
                id: item.id,
              },
            },
          });
        }
      } else if (item.type === 'promotion') {
        NavigationService.push<'DinningPromotionDetail'>(
          'DinningPromotionDetail',
          {
            id: item.id,
          }
        );
      }
    },
    [auth, navigateToLogin]
  );

  useEffect(() => {
    //dispatch(fetchEvents());
    getDashboard();
    getEvents();
    // dispatch(fetchPromotions());
  }, [dispatch, getEvents, getDashboard]);

  const tiles = useMemo(() => {
    const TILES = DASHBOARD_MENU;

    const result = [];
    let perRow = Math.min(4, Math.floor(screenWidth / 150));

    for (var i = 0; i < TILES.length; i += perRow) {
      var row = [];
      for (var j = 0; j < perRow && i + j < TILES.length; j++) {
        const index = i + j;
        row.push(
          <TouchableOpacity
            key={`${i}${j}`}
            style={{
              flex: 1,
              margin: 7,
              justifyContent: 'space-between',
              alignItems: 'stretch',
              maxWidth: 200,
              overflow: 'hidden',
              backgroundColor: '#00000006',
              padding: 8,
            }}
            onPress={() => {
              if (auth.loggedin === false && TILES[index].requiredLogin) {
                navigateToLogin();
              } else {
                if (TILES[index]) {
                  TILES[index].onPress();
                }
              }
            }}
          >
            <Image
              style={{
                width: 50,
                height: 50,
                margin: 10,
                resizeMode: 'contain',
                alignSelf: 'center',
                tintColor: STYLE_VARS.primaryColor,
              }}
              source={TILES[i + j]?.icon}
            />
            <Text
              style={{
                fontSize: 15,
                color: STYLE_VARS.primaryColor,
                textAlign: 'center',
                padding: 5,
                overflow: 'hidden',
              }}
            >
              {TILES[i + j]?.title}
            </Text>
          </TouchableOpacity>
        );
      }
      result.push(
        <View
          key={result.length}
          style={[
            {
              flexDirection: 'row',
              justifyContent: 'center',
              paddingLeft: 7,
              paddingRight: 7,
            },
            { width: screenWidth },
          ]}
        >
          {row}
        </View>
      );
    }

    return result;
  }, [screenWidth, navigateToLogin, auth.loggedin, DASHBOARD_MENU]);

  const renderSwiper = useMemo(() => {
    if (
      dashboard.isLoading === false &&
      dashboard.data.slider &&
      dashboard.data.slider.length > 0
    ) {
      return (
        <Swiper
          controlsProps={{
            prevPos: false,
            nextPos: false,
            DotComponent: () => <></>,
          }}
          timeout={5}
          loop
        >
          {dashboard.data.slider.map((item) => (
            <View key={item.id} style={{ flex: 1 }}>
              <TouchableOpacity onPress={() => handleRedirectBanner(item)}>
                <Image
                  source={{ uri: item.img ? item.img : '' }}
                  style={{
                    width: '100%',
                    height: isDesktop() ? 460 : 200,
                    resizeMode: 'cover',
                  }}
                />
              </TouchableOpacity>
              <View
                style={{
                  flexDirection: 'row',
                  justifyContent: 'center',
                  paddingTop: 5,
                }}
              >
                <Button
                  text="READ MORE"
                  style={[STYLE_VARS.blueButton, { paddingHorizontal: 40 }]}
                  onPress={() => handleRedirectBanner(item)}
                />
              </View>
            </View>
          ))}
        </Swiper>
      );
    } else {
      return (
        <View
          style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
        >
          <Text
            style={{
              fontSize: 25,
              color: STYLE_VARS.textColor,
            }}
          >
            {dashboard.isLoading === true ? 'LOADING ...' : 'COMMING SOON'}
          </Text>
        </View>
      );
    }
  }, [isDesktop, dashboard, handleRedirectBanner]);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: 1250,
            width: '90%',
            marginHorizontal: 'auto',
            marginTop: 10,
          }}
        >
          <PagePath
            pathSteps={[
              {
                name: 'Member area',
                onPress: () => {
                  NavigationService.push('Root', {
                    screen: 'HomeTab',
                  });
                },
              },
              {
                name: 'Member home',
              },
            ]}
          />
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              marginVertical: 30,
            }}
          >
            <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
              <User />
              <Promotions />
            </View>
            <View style={{ width: '75%' }}>
              <View style={{ width: '100%' }}>
                <View style={{ width: '100%', height: 500 }}>
                  {renderSwiper}
                </View>
                <Notices />
                {auth.loggedin === true && <Events />}
              </View>
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }
  return (
    <>
      <ScrollView showsVerticalScrollIndicator={false}>
        <View style={{ width: '100%', height: 250 }}>{renderSwiper}</View>
        <View
          style={[
            {
              paddingLeft: 20,
              paddingRight: 20,
              flexDirection: 'row',
            },
            state.loaded ? { opacity: 1 } : { opacity: 0 },
            isDesktop() && {
              maxWidth: MAX_WIDTH,
              width: '100%',
              alignSelf: 'center',
            },
          ]}
        >
          <View style={styles.container}>
            <User />
            <Notices />
            <View style={{ marginLeft: -20, marginRight: -20 }}>{tiles}</View>
            <Promotions />
            {/* <Notices />
            <Events />
            <News /> */}
          </View>
        </View>
        <Footer />
        <ECardMember openModal={openECard} setOpenModal={setOpenECard} />
      </ScrollView>

      {!state.loaded && (
        <View
          style={[
            STYLE_VARS.activityIndWrap as ViewStyle,
            {
              height: Dimensions.get('window').height,
            },
          ]}
        >
          <ActivityIndicator color={STYLE_VARS.fccBlue} size="large" />
        </View>
      )}
    </>
  );
};

export default Home;
